var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.6316 7.47825V15.0616H2.33331V7.47825C2.33331 4.64325 4.64331 2.33325 7.47831 2.33325H20.4866C23.3216 2.33325 25.6316 4.64325 25.6316 7.47825Z",
    fill: "#D44A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 15.0732V15.3066C2.33331 18.1532 4.64331 20.4516 7.47831 20.4516H11.9583C12.6 20.4516 13.125 20.9766 13.125 21.6182V22.7499C13.125 23.3916 12.6 23.9166 11.9583 23.9166H9.13498C8.65665 23.9166 8.25998 24.3132 8.25998 24.7916C8.25998 25.2699 8.64498 25.6666 9.13498 25.6666H18.8766C19.355 25.6666 19.7516 25.2699 19.7516 24.7916C19.7516 24.3132 19.355 23.9166 18.8766 23.9166H16.0533C15.4116 23.9166 14.8866 23.3916 14.8866 22.7499V21.6182C14.8866 20.9766 15.4116 20.4516 16.0533 20.4516H20.4983C23.345 20.4516 25.6433 18.1416 25.6433 15.3066V15.0732H2.33331Z",
    fill: "#D44A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon04);
export default __webpack_public_path__ + "static/media/ser-icon04.32883d47d2a30b99d40aa9541eb850d1.svg";
export { ForwardRef as ReactComponent };